function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions, mapState } from 'vuex';
import CheckboxRadioSwitch from '@nextcloud/vue/dist/Components/CheckboxRadioSwitch';
import SettingsSection from '@nextcloud/vue/dist/Components/SettingsSection';
import EmailSettings from '../components/EmailSettings';
import ActivityGrid from '../components/ActivityGrid';
export default {
  name: 'UserSettings',
  components: {
    CheckboxRadioSwitch: CheckboxRadioSwitch,
    SettingsSection: SettingsSection,
    EmailSettings: EmailSettings,
    ActivityGrid: ActivityGrid
  },
  mounted: function mounted() {
    this.setEndpoint({
      endpoint: '/apps/activity/settings'
    });
  },
  methods: _objectSpread({}, mapActions(['setEndpoint', 'toggleEmailEnabled'])),
  computed: _objectSpread(_objectSpread({}, mapState({
    emailEnabled: 'emailEnabled'
  })), {}, {
    settingDescription: function settingDescription() {
      if (this.emailEnabled) {
        return t('activity', 'Choose for which activities you want to get an email or push notification.');
      } else {
        return t('activity', 'Choose for which activities you want to get a push notification.');
      }
    }
  })
};